import React, { Component } from 'react';
import { ref } from '../config/constants'
import {formatPrice} from '../helpers/helpers'
import moment from 'moment'

import Modal from './Modal'
import InventoryDisplayProduct2 from './InventoryDisplayProduct2'

class PurchaseOrder extends Component {

    constructor(){
        super();
        this.handleChange =this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.state={
            info : {}
        }

    }

    handleChange(e){
        Object.keys(this.props.quotation).map(function (key){
                let list = this.props.quotation[key]
                if(list.quoteNumber === e.target.value){
                    this.setState({
                        info : list.customer
                    })
                }
        }.bind(this))
        this.props.setQuoteNumber(e.target.value)
    }
    handleSubmit(e){
        e.preventDefault()
        console.log(this.refs)
        let save ={
            quoteNumber :this.refs.quotationNumber.value,
            name : this.refs.customerName.value,
            address : this.refs.address.value,
            color : this.refs.color.value,
            date : this.refs.date.value,
            item : this.refs.item.value,
            totalLm : this.refs.gTotal.value,
            thickness : this.refs.thickness.value,
            orderLm :this.props.data,
            orderSheets :this.props.data2,
            orderStatus : "Done"
            
        }
        
        let statusUpdate={
            orderStatus : "Done"
        }

        ref.child("Quotation").child(this.refs.quotationNumber.value).update(statusUpdate)
        ref.child("PurchaseOrder").push(save).then(alert("New Purchase Order has been added"))
        
        window.location.assign("/purchaseorder/list")
    } 

    render() {
            
            const ids = Object.keys(this.props.data)
            const total = ids.reduce((prevTotal,key)=>{
                let value = this.props.data[key]
                return prevTotal + value.total
            },0)
            if(this.state.info.thickness){
                var thickness = "0." + this.state.info.thickness 
            }else{
                var thickness =""
            }
            
        return (                        
                <div >
                    <Modal id="InventoryDisplayProduct" title="Inventory Of Products">
                        <table id="ecom-products" className="table table-bordered table-striped table-vcenter">
                            <thead>
                                <tr>               
                                    <th className="text-center">Product Name</th>
                                    <th className="text-center">Unit</th>
                                     <th className="text-center">Length</th>
                                    <th className="text-center">Color</th>
                                    <th className="text-center">Count</th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    Object.keys(this.props.inventoryListProduct).map(key => {
                                        let list = this.props.inventoryListProduct[key]
                                       return <InventoryDisplayProduct2 key={key} index ={key} product={list}/>
                                    })
                                }
                            </tbody>
                        </table>
                    </Modal>
                    <div className="block"> 
                        <div className="row nomarginLR">
                            <div className="col-md-6">
                                <button className="btn btn-primary marginLeft3px" data-toggle="modal" data-target="#InventoryDisplayProduct"><i className="fa fa-folder-open" aria-hidden="true"></i> View Inventory</button>                                        
                            </div>
                        </div>                 
                        <form className="form-horizontal form-bordered" ref = {input => this.orderForm = input } onSubmit={this.handleSubmit} >                            
                            <h3 className="text-center paddingLeft20px">Cutting List</h3>
                            <div className="row nomarginLR">
                                
                                <div className="form-group col-md-6">
                                    <label className="col-md-5 control-label" >Quotation Number</label>
                                    <div className="col-md-4">
                                        <select className="form-control col-md-6"  name="quotationNumber" ref="quotationNumber" onChange={this.handleChange}>
                                            <option></option>                                            
                                            { 
                                                this.props.quotation &&
                                                Object.keys(this.props.quotation).map(function (key){
                                                    let list = this.props.quotation[key]
                                                    if(list.orderStatus !="Done" ){
                                                        return <option value={list.quoteNumber} key={key}> {list.quoteNumber} </option>
                                                    }
                                               }.bind(this))
                                            }
                                        </select>
                                    </div>
                                </div>
                                
                            </div>
                            <div className="row nomarginLR"> 
                                <div className="form-group col-md-6">
                                    <label className="col-md-5 control-label" >To</label>
                                    <div className="col-md-6">
                                        <input className="form-control"  ref="customerName" type="text" value={this.state.info && this.state.info.name}required/>
                                    </div>
                                </div>
                                <div className="form-group col-md-6">
                                    <label className="col-md-3 control-label" >Address</label>
                                    <div className="col-md-6">
                                        <input className="form-control"  ref="address" type="text"  value={this.state.info && this.state.info.location} required/>
                                    </div>
                                </div>
                            </div>
                            <div className="row nomarginLR">    
                                <div className="form-group col-md-6">
                                    <label className="col-md-5 control-label" >Item</label>
                                    <div className="col-md-6">
                                        <input className="form-control"   ref="item" type="text" value={this.state.info && this.state.info.item} required/>
                                    </div>
                                </div>
                                <div className="form-group col-md-6">
                                    <label className="col-md-3 control-label" >Thickness</label>
                                    <div className="col-md-6">
                                        <input className="form-control"  ref="thickness" type="text"  value={thickness} required/>
                                    </div>
                                </div>
                            </div>
                            <div className="row nomarginLR">    
                                <div className="form-group col-md-6">
                                    <label className="col-md-5 control-label" >Color</label>
                                    <div className="col-md-6">
                                        <input className="form-control" type="text" name="color" ref="color" required />                                            
                                    </div>
                                </div>
                                <div className="form-group col-md-6">
                                    <label className="col-md-3 control-label" >Date</label>
                                    <div className="col-md-6">
                                        <input className="form-control"  ref="date" type="text" value = {moment().format("MMMM DD YYYY")}/>
                                    </div>
                                </div>
                            </div>
                            <div className="wrapperTable">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th className="text-left ">
                                            <span>No. </span>                                             
                                            <button type="button" className="btn btn-primary" onClick={this.props.addFields}><i className="fa fa-plus-square" aria-hidden="true"></i> Add Fields </button>                                            
                                        </th>
                                        <th className="text-left ">Of Sheets</th>
                                        <th className="text-left ">Length</th>
                                        <th className="text-center ">Unit</th>
                                        <th className="text-center ">Total LM</th>
                                        <th className="text-center "></th>                                        
                                    </tr>
                                </thead>
                                <tbody className="forInputArea">
                                    {
                                        this.props.fieldList 
                                    }
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td>Grand Total</td>
                                        <td></td>
                                        <td>
                                            {total.toFixed(2)}
                                            <input className="form-control"  ref="gTotal" value={total} type="hidden" />
                                        </td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                            <div className="wrapperTable">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th className="text-left ">
                                            <span>No. </span>                                             
                                            <button type="button" className="btn btn-primary" onClick={this.props.addFields2}><i className="fa fa-plus-square" aria-hidden="true"></i> Add Fields </button>                                            
                                        </th>
                                        <th className="text-left ">Of Sheets</th>
                                        <th className="text-left ">Thickness</th>
                                        <th className="text-center ">Dimension</th>
                                        <th className="text-center ">Length</th>
                                        <th className="text-center ">Color</th>
                                        <th className="text-center "></th>                                        
                                    </tr>
                                </thead>
                                <tbody className="forInputArea">
                                    {
                                        this.props.fieldList2 
                                    }
                                    
                                </tbody>
                            </table>
                            </div>

                            <div className="submitContract text-center">
                               <button type="submit" className="btn btn-primary"><i className="fa fa-floppy-o"></i> Save</button>
                            </div>                            
                        </form>                      
                    </div>
                </div>                   
             
        );
    }
}

export default PurchaseOrder;



// WEBPACK FOOTER //
// ./src/components/PurchaseOrder.js